import { render, staticRenderFns } from "./scorecard-order.vue?vue&type=template&id=ab372e56&scoped=true"
import script from "./scorecard-order.vue?vue&type=script&lang=js"
export * from "./scorecard-order.vue?vue&type=script&lang=js"
import style0 from "./scorecard-order.vue?vue&type=style&index=0&id=ab372e56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab372e56",
  null
  
)

export default component.exports